import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './morning-polish.css'
import App from './App.tsx'
// Phone-only floating glass chrome. Imported after App so it follows every
// component stylesheet in the bundle (it only applies at max-width 640px).
import './styles/mobile-glass.css'
// Build's solid surfaces for the chat screen's frame (page, header strip, input box). Last on purpose.
import './styles/ops-surfaces.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Build marker — identifies the live build from the browser console
// (window.__REPUTIFLY_BUILD__) and forces a fresh content-hash on each deploy
// (bump the string per deploy).
;(window as unknown as Record<string, unknown>).__REPUTIFLY_BUILD__ =
  "2026-06-01-img-resilience-hardening"

// Boot loader fade-out lives in App.tsx → AppShell now. It waits for
// Firebase auth to resolve so there's a single, clean handoff straight
// from the inline loader to the real UI (no intermediate "loading…"
// text flash that used to appear during auth resolution).
